module.exports = __webpack_public_path__ + "static/media/favorite-blue.f2488250.svg";